import http from 'conversations-http/clients/http';
/**
 * Fetches a list of inboxes. See conversations-internal-schema/inbox/records/Inbox
 */
export const fetchInboxes = (ignoreWorkspaceFlag = false) => http.get('messages/v2/inbox/all', {
  query: {
    ignoreWorkspaceFlag
  }
});